import ButtonsGrid from '@ui/buttons/ButtonsFixed/ButtonsGrid'
import ModalWide from '@ui/components/Modal/variants/ModalWide'
import BannerLarge from '@ui/elements/BannerLarge'
import { StatusProps } from '@ui/elements/Status/types'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { ImageAny } from '@ui/utils/image'

interface ExtraDealModalProps {
  open: boolean
  close: () => void
  onAccept: () => void
  onSkip: () => void

  title: string
  desc?: string
  body?: string
  image?: ImageAny
  badge?: StatusProps
  translationPath?: string
}

function ExtraDealModal({
  open,
  close,
  onAccept,
  onSkip,
  title,
  desc,
  body,
  image,
  badge,
}: ExtraDealModalProps) {
  const { t } = useTranslation(['modals', 'ui'])

  return (
    <ModalWide
      open={open}
      close={close}
      cardComponentProps={{
        justifyContent: 'flex-end',
      }}
      hideBottomSpace
      body={
        <View className="gap-8 p-8">
          <BannerLarge
            title={title}
            desc={desc}
            body={body}
            image={image}
            badge={badge}
          />
          <View className="flex flex-row items-center justify-between gap-16 py-8">
            <ButtonsGrid
              buttons={[
                {
                  variant: 'filled',
                  label: t('ui:receive'),
                  iconStart: 'plus',
                  onPress: () => {
                    close()
                    onAccept()
                  },
                },
                {
                  variant: 'outlined',
                  label: t('ui:skip'),
                  iconEnd: 'chevrons-right',
                  onPress: () => {
                    close()
                    onSkip()
                  },
                },
              ]}
            />
          </View>
        </View>
      }
    />
  )
}

export default ExtraDealModal
